import { render } from "./LayoutBottom.vue?vue&type=template&id=368b2c88"
import script from "./LayoutBottom.vue?vue&type=script&lang=js"
export * from "./LayoutBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__